import { useEffect, useState } from 'react'
import { useLookup } from '../../hooks/use-api'
import { ReadOnlyField, TypeaheadOption } from '@msaf/core-react'

export interface ReadyOnlyLookupFieldProps {
  fieldId: string
  fieldFilters?: Record<string, string | number | boolean | null>
  value: string
  isSkeleton?: boolean
  showNameAndDescription?: boolean
  labelledBy: string
}

export default function ReadOnlyLookupField({
  fieldId,
  fieldFilters,
  value,
  labelledBy,
  isSkeleton,
}: ReadyOnlyLookupFieldProps) {
  const [selectedOption, setSelectedOption] = useState<string>()
  const [options, setOptions] = useState<TypeaheadOption[]>([])

  const { isLoading, isSuccess, data } = useLookup(fieldId, fieldFilters)

  useEffect(() => {
    // Find the passed value in the lookup options and set the selected option
    let selectedOption = null
    if (options.length && value) {
      selectedOption = options.find((opt: TypeaheadOption) => String(opt.value) === String(value))?.label
    }
    setSelectedOption(selectedOption ?? '')
  }, [options, value])

  useEffect(() => {
    if (isSuccess && data) {
      const opts: TypeaheadOption[] = data.map(({ id, name }: TypeaheadOption) => ({
        label: name,
        value: id,
      }))
      setOptions(opts)
    }
  }, [isSuccess, data, setOptions])

  return (
    <ReadOnlyField isSkeleton={isLoading || isSkeleton} labelledBy={labelledBy ?? fieldId} value={selectedOption} />
  )
}
